<div class="flex items-center datepicker">
  <input (dateChange)="startDateChange($event)" [matDatepicker]="picker" class="app-trim-ignore blend-border" (click)="picker.open()"  [placeholder]="placeholder" [formControl]="formControl" [min]="min" [max]="max" readonly>
  <mat-icon svgIcon="calendar_today" class="datepicker-icon" (click)="picker.open()"></mat-icon>
  <mat-datepicker #picker></mat-datepicker>
</div>
